import { EyeOutlined } from "@ant-design/icons";
import { UiButton } from "../../../../components";
import dayjs from "dayjs";
import Link from "antd/es/typography/Link";
import { formatPhoneNumber } from "../../../../utils/appUtils";
import { Tooltip, Checkbox } from "antd";

export const tabData = [
    { label: "Request", content: "REQUEST", key: "1" },
    { label: "Edit Request", content: "EDIT_REQUEST", key: "2" },
    { label: "Account Request", content: "ACCOUNT_REQUEST", key: "3" }
];

export const requestStatusOptions = [
    { key: "all", label: "All Status" },
    { key: "pending", label: "Pending" },
    { key: "approved", label: "Approved" },
    { key: "rejected", label: "Rejected" }
];

export const LAWYER_EDITABLE_FIELDS = [
    "salutation",
    "firstName",
    "middleName",
    "lastName",
    "barCouncilId",
    "experience",
    "qualification",
    "aboutAs",
    "stateCode",
    "districtCode",
    "cityCode",
    "pincode",
    "address1",
    "address2",
    "enrollmentNo",
    "email",
    "specialization"
];

export const LAWYER_REQUEST_HEADER_COLUMNS = ({
    actionRender,
    viewDocRender,
    handleBankDetails,
    selectedLawyerIds = [],
    handleSelectAll,
    isAllSelected = false,
    isIndeterminate = false,
    handleSelectLawyer,
    showCheckbox = false
}) => [
        {
            title: showCheckbox ? (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                    <Checkbox
                        checked={isAllSelected}
                        indeterminate={isIndeterminate}
                        onChange={(event) => handleSelectAll && handleSelectAll(event.target.checked)}
                        onClick={(event) => event?.stopPropagation()}
                    />
                    <span>SNo</span>
                </div>
            ) : "SNo",
            render: (_, detail, index) => {
                if (!showCheckbox) {
                    return (index ?? 0) + 1;
                }
                const lawyerId = detail?.lawyerId || detail?.id || detail?.requestId;
                const isChecked = Boolean(selectedLawyerIds?.includes(lawyerId));
                return (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                        <Checkbox
                            checked={isChecked}
                            onChange={(event) => {
                                event?.stopPropagation();
                                handleSelectLawyer && handleSelectLawyer(lawyerId, detail);
                            }}
                            onClick={(event) => event?.stopPropagation()}
                        />
                        <span>{(index ?? 0) + 1}</span>
                    </div>
                );
            },
            width: showCheckbox ? 80 : 60,
            align: 'center'
        },
        {
            title: "Date",
            dataIndex: "date",
            render: (_, detail) => dayjs(detail?.date).format("DD-MM-YYYY"),
            width: 100,
            align: 'center'
        },
        {
            title: "Advocate Name",
            width: 200,
            render: (_, record) => {
                const first = record?.firstName || "";
                const middle = record?.middleName || "";
                const last = record?.lastName || "";
                const fullName = `${first} ${middle} ${last}`.trim();
                const isLastLong = last?.length > 10;
                const shortName = isLastLong
                    ? `${first} ${middle} ${last?.slice(0, 3)}...`
                    : fullName;
                return (
                    <>
                        {isLastLong ? (
                            <Tooltip title={fullName}>
                                <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                            </Tooltip>
                        ) : (
                            <p style={{ padding: 0, margin: 0 }}>{shortName || "Nil"}</p>
                        )}
                    </>
                );
            }
        },
        {
            title: "BarCouncil ID",
            width: 120,
            render: (_, record) => {
                return <>{record?.barCouncilId || 'Nil'}</>
            }
        },
        {
            title: "Enrollment No",
            width: 120,
            render: (_, record) => {
                return <>{record?.enrollmentNo || 'Nil'}</>
            }
        },
        {
            title: "Contact Info",
            width: 160,
            render: (_, record) => {
                return (
                    <div>
                        <div style={{ color: '#000' }}>{record?.mobileNumber ? formatPhoneNumber(record?.mobileNumber) : 'Nil'}</div>
                    </div>
                );
            }
        },
        {
            title: "Email",
            width: 180,
            render: (record) => {
                return <div>{record?.email || 'Nil'}</div>
            }
        },
        {
            title: "Specialization",
            width: 180,
            align: "center",
            render: (record) => {
                const specs = record?.specialization || [];
                const joinedSpecs = specs?.join(", ");
                const displayText =
                    specs?.length > 2 ? `${specs?.slice(0, 2)?.join(", ")}...` : joinedSpecs;

                return (
                    <Tooltip title={joinedSpecs}>
                        <span>{displayText || "Nil"}</span>
                    </Tooltip>
                );
            }
        },
        {
            title: "year of Exp",
            dataIndex: "experience",
            width: 120,
            align: "left",
            render: (_, detail) => {
                return <div style={{ textAlign: "center" }}>{detail?.experience || "Nil"}</div>
            }
        },
        {
            title: "Qualification",
            dataIndex: "qualification",
            width: 150,
            render: (text) => text || "Nil"
        },
        {
            title: "Documents",
            width: 100,
            align: 'center',
            render: (_, record) => {
                let hasDocuments = false;
                if (Array.isArray(record?.documentUrl)) {
                    hasDocuments = record.documentUrl.length > 0;
                } else if (record?.documentUrl && typeof record.documentUrl === 'object') {
                    hasDocuments = Object.values(record.documentUrl).some(val => Boolean(val));
                } else {
                    hasDocuments = Boolean(record?.documentUrl) || Boolean(record?.documents);
                }
                return (
                    <Link onClick={() => viewDocRender && viewDocRender(record)}>
                        {hasDocuments ? "View" : "Nil"}
                    </Link>
                );
            }
        },
        {
            title: "Bank details",
            width: 120,
            align: "center",
            dataIndex: "bankDetails",
            render: (_, detail) => {
                return <>
                    <Link onClick={(event) => {
                        event?.stopPropagation();
                        handleBankDetails && handleBankDetails(detail);
                    }}>View</Link>
                </>
            }
        },
        {
            title: "About",
            dataIndex: "aboutAs",
            width: 200,
            ellipsis: true,
            render: (text) => text || "Nil"
        },

        {
            title: "Action",
            fixed: "right",
            width: 80,
            align: 'center',
            render: (_, record) => {
                if (!actionRender || !record) return null;
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <UiButton
                            type="text"
                            icon={<EyeOutlined />}
                            onClick={() => actionRender(record)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#000000'
                            }}
                        />
                    </div>
                );
            }
        }
    ];

export const formatUpiIds = (upiIds) => {
    if (!upiIds) return "Nil";
    if (typeof upiIds === "string") return upiIds || "Nil";
    if (Array.isArray(upiIds)) {
        if (upiIds.length === 0) return "Nil";
        const list = upiIds.map(item => {
            if (!item) return "";
            if (typeof item === "string") return item;
            return item?.upiId || item?.id || item?.upi || "";
        }).filter(Boolean);
        return list.length > 0 ? list.join(", ") : "Nil";
    }
    if (typeof upiIds === "object") {
        return upiIds?.upiId || upiIds?.id || upiIds?.upi || "Nil";
    }
    return String(upiIds);
};

export const ACCOUNT_REQUEST_HEADER_COLUMNS = ({
    actionRender,
    handleBankDetails,
    selectedLawyerIds = [],
    handleSelectAll,
    isAllSelected = false,
    isIndeterminate = false,
    handleSelectLawyer,
    showCheckbox = false
}) => [
        {
            title: showCheckbox ? (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                    <Checkbox
                        checked={isAllSelected}
                        indeterminate={isIndeterminate}
                        onChange={(event) => handleSelectAll && handleSelectAll(event.target.checked)}
                        onClick={(event) => event?.stopPropagation()}
                    />
                    <span>SNo</span>
                </div>
            ) : "SNo",
            render: (_, detail, index) => {
                if (!showCheckbox) {
                    return (index ?? 0) + 1;
                }
                const lawyerId = detail?.lawyerId || detail?.id;
                const isChecked = Boolean(selectedLawyerIds?.includes(lawyerId));
                return (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                        <Checkbox
                            checked={isChecked}
                            onChange={(event) => {
                                event?.stopPropagation();
                                handleSelectLawyer && handleSelectLawyer(lawyerId, detail);
                            }}
                            onClick={(event) => event?.stopPropagation()}
                        />
                        <span>{(index ?? 0) + 1}</span>
                    </div>
                );
            },
            width: showCheckbox ? 80 : 60,
            align: 'center'
        },
        {
            title: "Advocate Name",
            width: 180,
            render: (_, record) => {
                const profile = record?.lawyerDetails;
                const fullName = profile ? `${profile?.firstName || ""} ${profile?.middleName || ""} ${profile?.lastName || ""}`.trim() : "";
                const displayName = fullName || record?.lawyerId || "Nil";
                return (
                    <Tooltip title={displayName}>
                        <p style={{ padding: 0, margin: 0, fontWeight: 500 }}>{displayName}</p>
                    </Tooltip>
                );
            }
        },
        {
            title: "Contact Info",
            width: 150,
            render: (_, record) => {
                const phone = record?.lawyerDetails?.mobileNumber;
                return <div>{phone ? formatPhoneNumber(phone) : 'Nil'}</div>;
            }
        },
        {
            title: "Account Holder Name",
            width: 170,
            render: (_, record) => {
                const bankList = record?.bankDetails || [];
                const primaryBank = bankList.find(b => b?.primary) || bankList[0];
                return <div>{primaryBank?.accountHolderName || "Nil"}</div>;
            }
        },
        {
            title: "Bank Name",
            width: 150,
            render: (_, record) => {
                const bankList = record?.bankDetails || [];
                const primaryBank = bankList.find(b => b?.primary) || bankList[0];
                return <div>{primaryBank?.bankName || "Nil"}</div>;
            }
        },
        {
            title: "Account Number",
            width: 150,
            render: (_, record) => {
                const bankList = record?.bankDetails || [];
                const primaryBank = bankList.find(b => b?.primary) || bankList[0];
                return <div>{primaryBank?.decryptAccountNumber || primaryBank?.accountNumber || "Nil"}</div>;
            }
        },
        {
            title: "IFSC",
            width: 120,
            align: "center",
            render: (_, record) => {
                const bankList = record?.bankDetails || [];
                const primaryBank = bankList.find(b => b?.primary) || bankList[0];
                return <div>{primaryBank?.ifsc || "Nil"}</div>;
            }
        },
        {
            title: "Account Type",
            width: 130,
            align: "center",
            render: (_, record) => {
                const bankList = record?.bankDetails || [];
                const primaryBank = bankList.find(b => b?.primary) || bankList[0];
                return <div>{primaryBank?.accountType || "Nil"}</div>;
            }
        },
        {
            title: "UPI ID",
            width: 160,
            align: "center",
            render: (_, record) => {
                const upiValue = formatUpiIds(record?.upiIds);
                const isLong = upiValue?.length > 18;
                return isLong ? (
                    <Tooltip title={upiValue}>
                        <span>{upiValue.slice(0, 16)}...</span>
                    </Tooltip>
                ) : (
                    <span>{upiValue}</span>
                );
            }
        },
        {
            title: "Bank details",
            width: 120,
            align: "center",
            render: (_, record) => {
                return (
                    <Link onClick={(event) => {
                        event?.stopPropagation();
                        handleBankDetails && handleBankDetails(record);
                    }}>
                        View
                    </Link>
                );
            }
        },
        {
            title: "Action",
            fixed: "right",
            width: 100,
            align: 'center',
            render: (_, record) => {
                if (!actionRender || !record) return null;
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <UiButton
                            type="primary"
                            onClick={(event) => {
                                event?.stopPropagation();
                                actionRender(record);
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '4px'
                            }}
                        >
                            Approve
                        </UiButton>
                    </div>
                );
            }
        }
    ];